import type { FC } from 'react';

import { SvgIcon, type SvgIconProps } from '../SvgIcon';

const LH = 28;
const LW = 1.8;
const SH = 22;
const SW = 1.4;

const LY = -LH / 2;
const LX = -LW / 2;
const SY = -SH / 2;
const SX = -SW / 2;

export const MiloIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="-16 -16 32 32" {...props}>
    <defs>
      <mask id="milo-mask" maskUnits="userSpaceOnUse" x="-16" y="-16" width="32" height="32">
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(0)" />
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(45)" />
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(90)" />
        <rect x={LX} y={LY} width={LW} height={LH} fill="white" rx="0.25" transform="rotate(135)" />
        <rect x={SX} y={SY} width={SW} height={SH} fill="white" rx="0.25" transform="rotate(22.5)" />
        <rect x={SX} y={SY} width={SW} height={SH} fill="white" rx="0.25" transform="rotate(67.5)" />
        <rect x={SX} y={SY} width={SW} height={SH} fill="white" rx="0.25" transform="rotate(112.5)" />
        <rect x={SX} y={SY} width={SW} height={SH} fill="white" rx="0.25" transform="rotate(157.5)" />
      </mask>
    </defs>
    <circle cx="0" cy="0" r={LH / 2} fill="currentColor" mask="url(#milo-mask)" />
  </SvgIcon>
);
